import React, {useState} from 'react';
import {Form, FormGroup, Input, Container} from "reactstrap";
import * as emailjs from "@emailjs/browser";
import useWindowDimensions from "../components/useWindowDimensions";
import Swal from 'sweetalert2'

function Contact(props) {
    const {height, width} = useWindowDimensions();

    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [msg, setMsg] = useState("");

    const Handler = (name) => {
        setName(name);
        console.log(name);
    };


    function handleClick() {

        //Boş Olup olmadığı check edilecek bir de service id değişecek
        if (name === "" || phone === "" || msg === "") {
            Swal.fire({
                title: 'Lütfen Bütün Alanları Doldurunuz',
                icon: 'error',
                confirmButtonColor: '#25053b'

            })
        } else {
            var data = {
                name: name,
                phone: phone,
                message: msg,
            };
            emailjs.send(
                'service_9joqq4p',
                'template_qeiw0rw',
                data,
                'wxzzqAYhW4k_VTJww'
            )
                .then(
                    (result) => {
                        Swal.fire({
                            title: 'En Kısa Sürede Sizinle İletişime Geçeceğiz',
                            icon: 'success',
                            confirmButtonColor: '#25053b'

                        }).then(function () {
                            window.location.reload();
                        })
                    },
                    (error) => {
                        console.log(error.text);
                        alert("Gönderim hatası.");
                    }
                );
        }
    }

    return (

        <Container fluid={true}>
            <div className="section contact-page-container mt-5">
                <div className="form-container">

                    <div className="left" style={{marginLeft: '10%'}}>
                        <div className="header">
                            <h2 className="animation a1">İletişim</h2>
                            <h4 className="animation a2">Lütfen iletişim bilgileriniz eksiksiz doldurunuz</h4>
                            <h4 className="animation a1">İletişim Numaralarımız: 05459480019 - 05013760115 </h4>
                        </div>
                        <div className="form">
                            <input type="name" className="form-field animation a3" placeholder="İsminiz" value={name}
                                   onChange={e => setName(e.target.value)}/>
                            <input type="text" className="form-field animation a4" placeholder="Telefon Numaranız"
                                   value={phone}
                                   onChange={e => setPhone(e.target.value)}/>

                            <Form>
                                <FormGroup controlId="exampleForm.ControlTextarea1">
                                    <Input as="textarea" className="form-field animation a4" rows={3}
                                           placeholder="Mesajınız" value={msg}
                                           onChange={e => setMsg(e.target.value)}/>
                                </FormGroup>
                            </Form>
                            <button className="animation a6" onClick={() => handleClick()}>Gönder</button>
                        </div>

                    </div>
                    {width > 700 ? <div className="right"></div> : <div></div>}

                </div>
            </div>
        </Container>
    );
}

export default Contact;
